/* @flow */
import React from 'react';
import Token from 'components/Token.jsx';
import Text from 'components/Text.jsx';

import cx from 'classnames';
import styles from './styles/UniversalComposerRecipientToken.css';

export default class UniversalComposerRecipientToken extends React.Component {
  static propTypes = {
    children(props, propName) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('UniversalComposerRecipientToken expects two child elements');
      }
    },
  };

  render() {
    const { children, ...tokenProps } = this.props;

    const [avatar, text] = children;
    const styledAvatar = React.cloneElement(avatar, {
      className: cx(
        avatar.props.className,
        styles.avatar
      ),
    });

    return (
      <Token className={styles.this} {...tokenProps}>
        <div className={styles.container}>
          {styledAvatar}
          <Text className={styles.name}>
            {text}
          </Text>
        </div>
      </Token>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chat/components/UniversalComposerRecipientToken.jsx